import { render } from "./QuickMatrixFooter.vue?vue&type=template&id=66ebc556&scoped=true"
const script = {}

import "./QuickMatrixFooter.vue?vue&type=style&index=0&id=66ebc556&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ebc556"]])

export default __exports__